export const _initialState = {
  digitalData: { event: [] }
};
